import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Scaffolded page. Used for every inner route where the client hasn't sent
 * final copy yet. Renders a real heading + intro so the URL is functional and
 * navigable, but clearly labels itself as scaffolded.
 */
export default function ScaffoldedPage({ title, intro, category }) {
  return (
    <div data-testid={`scaffold-${(title || "page").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <section className="bg-white">
        <div className="mx-auto max-w-4xl px-4 py-20 lg:px-6 lg:py-28">
          {category ? (
            <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">{category}</div>
          ) : null}
          <h1 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-wafa-ink/80 lg:text-lg">
            {intro}
          </p>

          <div className="mt-10 rounded-lg border border-dashed border-wafa-deep/20 bg-wafa-cream/40 p-6 text-sm text-wafa-ink/70">
            Full page copy is being finalised. In the meantime, book a scoping call and we'll walk
            you through this in person.
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-md bg-wafa-primary px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-wafa-deep"
              data-testid="scaffold-cta"
            >
              Book a Free Scoping Call
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-md border border-wafa-deep/20 px-5 py-3 text-sm font-semibold text-wafa-deep hover:bg-wafa-cream/50"
            >
              <ArrowLeft className="h-4 w-4" /> Back to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
